module.exports = "/_next/static/images/adce64e7bacd9893a6efbe9ab8ed8d6b-man-with-cellphone-md@3x.jpg";